import { useIntl } from 'react-intl';

import { DownloadableCert } from '../DownloadableCert';
import type { DownloadProps } from '../DownloadableLimitededition';

import { ReactComponent as COSC } from '@/assets/icons/COSCCertificate.svg';

import * as M from '../../messages';
export const DownloadableCOSC = ({ channel, sn }: DownloadProps) => {
  const { formatMessage } = useIntl();
  return (
    <DownloadableCert
      Svg={COSC}
      channel={channel}
      data-test-id='DownloadableCOSCDownloadableCert'
      fileName='cosc'
      sn={sn}
      text={formatMessage(M.messages.coscCertificate)}
    />
  );
};

DownloadableCOSC.displayName = 'DownloadableCOSC';
